module.exports = __webpack_public_path__ + "static/media/vncss-logo.1f8f9afa.png";